<template>
  <svg id="raam" viewBox="0 0 64 64">
    <path
      d="M2.2,60.7v-5.5H5h54.3H62v5.5L2.2,60.7z M6.9,3l50.3,0v50.3H6.9V3z M5,1v52.3H0.2v9.4l63.8,0v-9.4h-4.8V1L5,1z"
    />
    <path
      d="M35.4,49.2v-26l11,1.3v9.5c-1.2,0.4-2.1,1.5-2.1,2.9c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1
                c0-1.3-0.9-2.5-2.1-2.9v-9.3l4.8,0.6v23.8H35.4z M11.1,20.2l18.4,2.2v26.7H11.1V20.2z M11.1,15.6l18.4,1.5v3.4l-18.4-2.2V15.6z
                 M11.1,11.6h18.4v3.4l-18.4-1.5V11.6z M53.1,7.1v2.5H33.4v0.6v1.4V12v1.3v2.1v2v3.6v2v24.6h0v1.7h-2v-1.7V46V22.7v-2v-3.5v-2v-1.9
                V12v-0.4v-1.4V9.6H11.1V7.1H53.1z M53.1,11.6v5.3l-17.8-1.4v-3.9H53.1z M47.4,35.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1
                c-0.6,0-1.1-0.5-1.1-1.1C46.3,36.3,46.8,35.9,47.4,35.9 M48.2,22.7l-12.8-1.6v-3.6l17.8,1.4v4.4l-4.8-0.6v0H48.2z M9.1,51.2h46V5.1
                h-46V51.2z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconRaam extends Vue {}
</script>
